var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"padding-top":"0px"}},[(!_vm.logined)?_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"mb-4"},[_c('h1',{staticClass:"display-2 font-weight-bold mb-3"},[_vm._v(" Welcome to PhotoLog ")]),_c('p',{staticClass:"subheading font-weight-regular"})])],1):_vm._e(),(_vm.logined)?_c('ListTable'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }